// src/pages/LifestyleTips.js

import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function LifestyleTips() {
  return (
    <>
      {/* Inline Style for Montserrat if no global CSS */}
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap');

          body, h1, h2, h3, h4, h5, h6, p, .btn, .navbar-brand, .nav-link {
            font-family: 'Montserrat', sans-serif !important;
          }
        `}
      </style>

      {/* ========== HERO BANNER ========== */}
      <div
        style={{
          backgroundColor: '#c8102e',
          color: '#fff',
          padding: '6rem 0',
          textAlign: 'center',
        }}
      >
        <Container>
          <h1 style={{ fontWeight: '700', fontSize: '2.5rem' }}>
            Lifestyle Tips for BFS
          </h1>
          <p style={{ fontSize: '1.1rem', maxWidth: '700px', margin: '1rem auto' }}>
            Discover practical ways to minimize twitch frequency, support your wellbeing, and 
            live confidently with BFS.
          </p>
        </Container>
      </div>

      {/* ========== ARTICLE CONTENT ========== */}
      <div style={{ backgroundColor: '#f5f5f5', padding: '4rem 0' }}>
        <Container>
          <Row className="justify-content-center">
            <Col md={10}>
              <h2 style={{ fontWeight: '700', marginBottom: '1.5rem' }}>
                Why Lifestyle Matters
              </h2>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                For individuals with Benign Fasciculation Syndrome (BFS), certain daily habits can
                either aggravate or alleviate muscle twitching. Simple lifestyle changes often help
                reduce twitch frequency and provide better overall well-being.
              </p>

              <h3 style={{ fontWeight: '700', marginTop: '2rem', marginBottom: '1rem' }}>
                Nutrition & Hydration
              </h3>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                Maintaining a balanced diet rich in vitamins and minerals supports healthy nerve 
                function. Proper hydration also ensures that muscles and nerves work optimally.
                Consider:
              </p>
              <ul style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
                <li>Incorporating fruits, vegetables, and whole grains</li>
                <li>Minimizing processed foods and excessive sodium</li>
                <li>Monitoring caffeine and alcohol intake</li>
              </ul>

              <h3 style={{ fontWeight: '700', marginTop: '2rem', marginBottom: '1rem' }}>
                Physical Activity & Exercise
              </h3>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                Regular movement, such as walking, swimming, or light strength training, can help
                stabilize muscle function and reduce stress—a known twitch trigger. Overexertion, 
                however, may temporarily aggravate twitches, so moderation is key.
              </p>

              <h3 style={{ fontWeight: '700', marginTop: '2rem', marginBottom: '1rem' }}>
                Sleep & Rest
              </h3>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                Adequate rest is crucial for muscle recovery and nerve health. Establishing a 
                consistent sleep routine—aiming for 7-9 hours—can make a noticeable difference 
                in twitch frequency and overall energy levels.
              </p>

              <h3 style={{ fontWeight: '700', marginTop: '2rem', marginBottom: '1rem' }}>
                Stress Management
              </h3>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                Stress often magnifies BFS symptoms. Incorporating relaxation techniques, 
                meditation, or mindfulness exercises can reduce the nervous system’s tendency 
                to misfire, thus lessening twitch episodes.
              </p>

              <h3 style={{ fontWeight: '700', marginTop: '2rem', marginBottom: '1rem' }}>
                Listening to Your Body
              </h3>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                Everyone’s BFS experience is unique. Track your triggers and note which lifestyle 
                adjustments help the most. Over time, this personalized approach leads to more 
                effective management of twitching.
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      {/* ========== FOOTER SECTION (IF NOT USING GLOBAL FOOTER) ========== */}
      <div style={{ backgroundColor: '#222', color: '#fff', padding: '2rem 0', textAlign: 'center' }}>
        <Container>
          <p className="mb-1" style={{ fontSize: '1rem' }}>
            © {new Date().getFullYear()} BFS Organization. All rights reserved.
          </p>
          <p style={{ opacity: 0.8, fontSize: '1rem' }}>
            <em>Not medical advice. Always consult with a healthcare professional.</em>
          </p>
        </Container>
      </div>
    </>
  );
}

export default LifestyleTips;
